// root redux reducer

import { reducer as respondent } from 'ducks/respondent'
import { reducer as timer } from 'ducks/timer'
import { reducer as auth } from 'ducks/auth'
import { reducer as orm } from 'orm/reducer'
import { reducer as ux } from 'ducks/ux'

export default { respondent, timer, auth, ux, orm }
